/** @jsxImportSource @emotion/react */

import Image from 'next/image';

import { media } from '@stories/theming/settings';

import { SectionHeader, section } from './VitafyAboutUsPage';

export const Quality: React.FC = () => {
  const subtitle = `
            <p>
            Nach einem Jahrzehnt steht vitafy für Expertise und
             <span style="font-weight: bold"> Qualitätssicherung</span>
          </p>
          <p>
            Mit dem <span style="font-weight: bold">Trusted Shops-Siegel</span> und 
             <span style="font-weight: bold">Top Bewertungen</span> garantieren wir unseren Kunden Vertrauen
            und Zuverlässigkeit.
          </p>`;
  return (
    <section css={{ ...section, [media('desktop')]: { padding: '5rem var(--offset) 0rem' } }}>
      <SectionHeader title="Qualität" subtitle={subtitle} />
      <div css={{ display: 'flex', justifyContent: 'center' }}>
        <Image
          css={{ margin: 'auto', maxWidth: '100%' }}
          alt="vitafy logo"
          unoptimized
          width={180}
          height={180}
          src={'https://cdnsf1.vitafy.de/asset/images/etrusted-logo.svg'}
        />
      </div>
    </section>
  );
};
